import services from 'services';

export const NUMBER_URL = '/tb/api/v2/authenticated/number';
export const DOMAIN_URL = '/tb/api/v2/authenticated/domain';

class PerformanceTrackerService {
  numberPerformanceSearch(filters) {
    return services.post(`${NUMBER_URL}/performance-tracking/search`, filters);
  }

  numberPerformanceCount(filters) {
    return services.post(`${NUMBER_URL}/performance-tracking/count`, filters);
  }

  domainPerformanceSearch(filters) {
    return services.post(`${DOMAIN_URL}/performance-tracking/search`, filters);
  }

  domainPerformanceCount(filters) {
    return services.post(`${DOMAIN_URL}/performance-tracking/count`, filters);
  }

  loadDidPerformanceInGroup(
    body = {
      groupId: '',
      phones: [''],
    },
    configs
  ) {
    return services.post(`${NUMBER_URL}/loadDidPerformanceInGroup`, body, configs);
  }

  loadDomainPerformanceInGroup(
    body = {
      groupId: '',
      domains: [''],
    },
    configs
  ) {
    return services.post(
      `${DOMAIN_URL}/performance-tracking/getDomainPerformanceInGroup`,
      body,
      configs
    );
  }
}

export default new PerformanceTrackerService();
